// Pause other previews, including sections loaded in the theme editor.
document.addEventListener('play', (event) => {
  if (!event.target.matches('audio[data-mr-preview]')) return;
  document.querySelectorAll('audio[data-mr-preview]').forEach(audio => {
    if (audio !== event.target) audio.pause();
  });
}, true);
// Dawn uses novalidate: validate explicit digital-delivery consent before its AJAX handler.
document.addEventListener('submit', (event) => {
  const checkbox = event.target.querySelector('[data-mr-digital-consent]');
  if (checkbox && !checkbox.checked) {
    event.preventDefault();
    event.stopImmediatePropagation();
    checkbox.reportValidity();
    checkbox.focus();
  }
}, true);
